import React from 'react';

interface ServiceProfileWebsiteProps {
  websiteUrl?: string;
  subscriptionTier?: string;
  onClickWebsite: () => void;
}

export const ServiceProfileWebsite: React.FC<ServiceProfileWebsiteProps> = ({
  websiteUrl,
  subscriptionTier,
  onClickWebsite,
}) => {
  if (!websiteUrl || subscriptionTier !== 'premium_tier') return null;
  const formatted = websiteUrl.startsWith('http') ? websiteUrl : `https://${websiteUrl}`;
  return (
    <section className="grid gap-4 border-t border-brand-cloud pt-7 md:grid-cols-[minmax(0,0.28fr)_minmax(0,0.72fr)] md:gap-8">
      <h3 className="public-card-title">Website</h3>
      <a
        href={formatted}
        target="_blank"
        rel="noreferrer"
        onClick={onClickWebsite}
        className="text-sm font-medium text-brand-ink underline decoration-brand-cloud underline-offset-4 hover:text-harbour"
      >
        {websiteUrl}
      </a>
    </section>
  );
};
